/**
 * Medusa Atelier — Kisiye Ozel Tasarim
 * Modlar: Fotograf | Prompt | Fotograf+Prompt | Tasarimim (mockup)
 */
(function () {
  'use strict';

  var IMAGES = {
    dikdortgen: {
      gold: 'https://cdn.shopify.com/s/files/1/0606/0313/8298/files/gold_dikdortgen.jpg?v=1773527282',
      silver: 'https://cdn.shopify.com/s/files/1/0606/0313/8298/files/silver_dikdortgen.jpg?v=1773527306',
      rosegold: 'https://cdn.shopify.com/s/files/1/0606/0313/8298/files/rosegold_dikdortgen.jpg?v=1773527295',
      erkek: 'https://cdn.shopify.com/s/files/1/0606/0313/8298/files/erkek_dikdortgen.jpg?v=1773527266'
    },
    oval: {
      gold: 'https://cdn.shopify.com/s/files/1/0606/0313/8298/files/gold_oval.jpg?v=1773527286',
      silver: 'https://cdn.shopify.com/s/files/1/0606/0313/8298/files/silver_oval.jpg?v=1773527312',
      rosegold: 'https://cdn.shopify.com/s/files/1/0606/0313/8298/files/rosegold_oval.jpg?v=1773527298',
      erkek: 'https://cdn.shopify.com/s/files/1/0606/0313/8298/files/erkek_oval.jpg?v=1773527272'
    },
    yuvarlak: {
      gold: 'https://cdn.shopify.com/s/files/1/0606/0313/8298/files/gold_yuvarlak.jpg?v=1773527292',
      silver: 'https://cdn.shopify.com/s/files/1/0606/0313/8298/files/silver_yuvarlak.jpg?v=1773527319',
      rosegold: 'https://cdn.shopify.com/s/files/1/0606/0313/8298/files/rosegold_yuvarlak.jpg?v=1773527303',
      erkek: 'https://cdn.shopify.com/s/files/1/0606/0313/8298/files/erkek_yuvarlak.jpg?v=1773527277'
    }
  };

  var DAILY_LIMIT_GUEST = 3;
  var DAILY_LIMIT_MEMBER = 5;
  var DAILY_LIMIT = DAILY_LIMIT_GUEST;
  var LIMIT_KEY = 'cd_rate_limit';
  var LOADING_MESSAGES = [
    'Tasar\u0131m\u0131n\u0131z haz\u0131rlan\u0131yor...',
    'AI \u00e7izim yap\u0131yor...',
    'Detaylar ekleniyor...',
    'Neredeyse haz\u0131r...',
    'Kolyeniz tamamlan\u0131yor...'
  ];

  var BTN_GENERATE_TEXT = 'Tasar\u0131m\u0131 Olu\u015ftur';
  var BTN_MOCKUP_TEXT = 'Kolye \u00dczerinde G\u00f6ster';

  var state = {
    shape: null, color: null, mode: 'photo', style: 'minimalist',
    customerImageBase64: null, comboImageBase64: null, myDesignBase64: null,
    generatedImageUrl: null, selectedOptions: {},
    apiUrl: '', productData: null, loadingTimer: null
  };

  function init() {
    var section = document.getElementById('CustomDesign');
    if (!section) return;
    document.body.classList.add('cd-page');

    var dataEl = document.getElementById('custom-design-data');
    if (dataEl) {
      try {
        var data = JSON.parse(dataEl.textContent);
        state.apiUrl = data.apiUrl || '';
        state.productData = data.product || null;
        if (data.customer && data.customer.loggedIn) {
          DAILY_LIMIT = DAILY_LIMIT_MEMBER;
        }
      } catch (e) {}
    }

    bindShapeButtons();
    bindColorButtons();
    bindTabs();
    bindUpload();
    bindComboUpload();
    bindMyDesignUpload();
    bindStyles();
    bindPromptSuggestions();
    bindGenerate();
    bindRetry();
    bindDownload();
    bindVariants();
    bindCart();
    updateRateLimitDisplay();
  }

  /* ── Rate Limit ── */
  function getRateData() {
    try {
      var d = JSON.parse(localStorage.getItem(LIMIT_KEY));
      var today = new Date().toISOString().slice(0, 10);
      if (d && d.date === today) return d;
    } catch (e) {}
    return { date: new Date().toISOString().slice(0, 10), count: 0 };
  }
  function incrementRate() {
    var d = getRateData(); d.count++;
    localStorage.setItem(LIMIT_KEY, JSON.stringify(d));
    updateRateLimitDisplay();
  }
  function canGenerate() { return getRateData().count < DAILY_LIMIT; }
  function updateRateLimitDisplay() {
    var d = getRateData(), remaining = DAILY_LIMIT - d.count;
    var el = document.getElementById('cdRateLimit');
    if (el) {
      el.textContent = remaining + '/' + DAILY_LIMIT + ' tasar\u0131m hakk\u0131n\u0131z kald\u0131.';
      if (remaining <= 0) {
        el.classList.add('cd-rate-limit--exhausted');
        var btn = document.getElementById('cdGenerateBtn');
        if (btn) { btn.disabled = true; btn.textContent = 'G\u00fcnl\u00fck limit doldu'; }
      }
    }
  }

  /* ── Step 1: Shape ── */
  function bindShapeButtons() {
    on('.cd-shape-btn', 'click', function () {
      activateInGroup(this, '.cd-shape-btn');
      state.shape = this.dataset.shape;
      state.color = null;
      deactivateAll('.cd-color-btn');
      show('#cdStep2'); hide('#cdPreview'); hide('#cdStep3'); hideResult();
      smoothScroll('#cdStep2');
    });
  }

  /* ── Step 2: Color ── */
  var COLOR_TO_VARIANT = { gold: 'Gold', silver: 'Silver', rosegold: 'Rose Gold', erkek: 'Erkek' };
  function bindColorButtons() {
    on('.cd-color-btn', 'click', function () {
      activateInGroup(this, '.cd-color-btn');
      state.color = this.dataset.color;
      updateRefImage();
      show('#cdStep3'); hideResult(); autoSelectColorVariant();
      smoothScroll('#cdPreview');
    });
  }
  function autoSelectColorVariant() {
    var target = COLOR_TO_VARIANT[state.color];
    if (!target) return;
    document.querySelectorAll('.cd-variant-btn').forEach(function (btn) {
      var val = btn.dataset.value.trim();
      // Auto-select Material match
      if (val === target) {
        activateInGroup(btn, '.cd-variant-btn[data-option-name="' + btn.dataset.optionName + '"]');
        state.selectedOptions[btn.dataset.optionName] = val;
      }
      // Auto-select "Necklace" for Product option
      if (val === 'Necklace') {
        activateInGroup(btn, '.cd-variant-btn[data-option-name="' + btn.dataset.optionName + '"]');
        state.selectedOptions[btn.dataset.optionName] = val;
      }
    });
    updateCartBtn();
  }

  function updateRefImage() {
    if (!state.shape || !state.color) return;
    var url = IMAGES[state.shape] && IMAGES[state.shape][state.color];
    if (!url) return;
    var img = document.getElementById('cdRefImage');
    if (img) { img.src = url; img.alt = state.color + ' ' + state.shape; }
    show('#cdPreview');
  }
  function getRefUrl() {
    if (!state.shape || !state.color) return '';
    return (IMAGES[state.shape] && IMAGES[state.shape][state.color]) || '';
  }

  /* ── Tabs ── */
  function bindTabs() {
    on('.cd-tab', 'click', function () {
      var mode = this.dataset.mode;
      activateInGroup(this, '.cd-tab');
      document.querySelectorAll('.cd-tab-panel').forEach(function (p) {
        p.classList.toggle('is-active', p.dataset.panel === mode);
      });
      state.mode = mode;
      var styleSection = document.getElementById('cdStyleSection');
      var genBtn = document.getElementById('cdGenerateBtn');
      if (mode === 'mydesign') {
        if (styleSection) styleSection.style.display = 'none';
        if (genBtn) genBtn.textContent = BTN_MOCKUP_TEXT;
      } else {
        if (styleSection) styleSection.style.display = '';
        if (genBtn) genBtn.textContent = BTN_GENERATE_TEXT;
      }
    });
  }

  /* ── File Uploads ── */
  function bindUpload() { bindUploadArea('cdUploadArea', 'cdUploadInput', 'cdUploadPreview', 'customerImageBase64'); }
  function bindComboUpload() { bindUploadArea('cdComboUploadArea', 'cdComboUploadInput', 'cdComboUploadPreview', 'comboImageBase64'); }
  function bindMyDesignUpload() { bindUploadArea('cdMyDesignUploadArea', 'cdMyDesignInput', 'cdMyDesignPreview', 'myDesignBase64'); }

  function bindUploadArea(areaId, inputId, previewId, stateKey) {
    var area = document.getElementById(areaId);
    var input = document.getElementById(inputId);
    if (!area || !input) return;
    area.addEventListener('click', function () { input.click(); });
    area.addEventListener('dragover', function (e) { e.preventDefault(); this.classList.add('is-dragover'); });
    area.addEventListener('dragleave', function () { this.classList.remove('is-dragover'); });
    area.addEventListener('drop', function (e) {
      e.preventDefault(); this.classList.remove('is-dragover');
      if (e.dataTransfer.files.length) processFile(e.dataTransfer.files[0], areaId, previewId, stateKey);
    });
    input.addEventListener('change', function () {
      if (this.files.length) processFile(this.files[0], areaId, previewId, stateKey);
    });
  }

  function processFile(file, areaId, previewId, stateKey) {
    if (!file.type.startsWith('image/')) { showError('L\u00fctfen bir g\u00f6rsel se\u00e7in.'); return; }
    if (file.size > 10 * 1024 * 1024) { showError('Dosya 10MB\u2019dan k\u00fc\u00e7\u00fck olmal\u0131.'); return; }
    var reader = new FileReader();
    reader.onload = function (e) {
      state[stateKey] = e.target.result;
      var preview = document.getElementById(previewId);
      if (preview) { preview.src = e.target.result; preview.style.display = 'block'; }
      var area = document.getElementById(areaId);
      if (area) {
        area.classList.add('has-file');
        var t = area.querySelector('.cd-upload-text');
        if (t) t.textContent = file.name;
      }
    };
    reader.readAsDataURL(file);
  }

  /* ── Styles ── */
  function bindStyles() {
    on('.cd-style-btn', 'click', function () {
      activateInGroup(this, '.cd-style-btn');
      state.style = this.dataset.style;
    });
  }

  /* ── Prompt Suggestions ── */
  function bindPromptSuggestions() {
    on('.cd-suggestion', 'click', function () {
      var el = document.getElementById('cdPrompt');
      if (el) { el.value = this.dataset.prompt; el.focus(); }
    });
  }

  /* ── Generate ── */
  function bindGenerate() {
    var btn = document.getElementById('cdGenerateBtn');
    if (btn) btn.addEventListener('click', doGenerate);
  }

  function doGenerate() {
    hideError();
    var refUrl = getRefUrl();
    if (!refUrl) { showError('L\u00fctfen form ve renk se\u00e7in.'); return; }
    if (!state.apiUrl) { showError('API ba\u011flant\u0131s\u0131 ayarlanmam\u0131\u015f.'); return; }
    if (!canGenerate()) {
      showError('G\u00fcnl\u00fck limit doldu (' + DAILY_LIMIT + '/' + DAILY_LIMIT + '). Yar\u0131n tekrar deneyin.');
      return;
    }

    var payload = { referenceImage: refUrl, mode: state.mode, style: state.style };

    if (state.mode === 'mydesign') {
      if (!state.myDesignBase64) { showError('L\u00fctfen tasar\u0131m\u0131n\u0131z\u0131 y\u00fckleyin.'); return; }
      payload.customerImage = state.myDesignBase64;
      payload.mode = 'photo';
      payload.style = 'realistic';
      payload.prompt = 'Place this exact design onto the pendant surface faithfully. Do not interpret or redraw.';
    } else if (state.mode === 'prompt') {
      var el = document.getElementById('cdPrompt');
      var prompt = el ? el.value.trim() : '';
      if (!prompt) { showError('L\u00fctfen tasar\u0131m a\u00e7\u0131klamas\u0131 yaz\u0131n.'); return; }
      payload.prompt = prompt;
    } else if (state.mode === 'combo') {
      if (!state.comboImageBase64) { showError('L\u00fctfen bir foto\u011fraf y\u00fckleyin.'); return; }
      payload.customerImage = state.comboImageBase64;
      var comboEl = document.getElementById('cdComboPrompt');
      payload.prompt = comboEl ? comboEl.value.trim() : '';
      payload.mode = 'photo';
    } else {
      if (!state.customerImageBase64) { showError('L\u00fctfen bir foto\u011fraf y\u00fckleyin.'); return; }
      payload.customerImage = state.customerImageBase64;
    }

    var btn = document.getElementById('cdGenerateBtn');
    if (btn) btn.disabled = true;
    startLoadingProgress();

    fetch(state.apiUrl + '/api/generate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function (res) {
      if (!res.ok) throw new Error('API ' + res.status);
      return res.json();
    })
    .then(function (data) {
      stopLoadingProgress();
      var btn = document.getElementById('cdGenerateBtn');
      if (btn) btn.disabled = !canGenerate();
      if (data.success && data.imageUrl) {
        state.generatedImageUrl = data.imageUrl;
        incrementRate();
        saveDesignToHistory(data.imageUrl);
        showResultWithCart(data.imageUrl);
      } else {
        showError(data.error || 'Tasar\u0131m olu\u015fturulamad\u0131.');
      }
    })
    .catch(function (err) {
      stopLoadingProgress();
      var btn = document.getElementById('cdGenerateBtn');
      if (btn) btn.disabled = !canGenerate();
      showError('Ba\u011flant\u0131 hatas\u0131. Tekrar deneyin.');
      console.error('CD error:', err);
    });
  }

  /* ── Loading Progress ── */
  function startLoadingProgress() {
    show('#cdLoading'); hide('#cdResult');
    smoothScroll('#cdLoading');
    var fill = document.getElementById('cdProgressFill');
    var status = document.getElementById('cdLoadingStatus');
    var timer = document.getElementById('cdLoadingTimer');
    var startTime = Date.now();
    var duration = 20000;
    var msgIndex = 0;

    state.loadingTimer = setInterval(function () {
      var elapsed = Date.now() - startTime;
      var progress = Math.min(elapsed / duration * 90, 90);
      var remaining = Math.max(Math.ceil((duration - elapsed) / 1000), 1);

      if (fill) fill.style.width = progress + '%';
      if (timer) timer.textContent = '~' + remaining + 'sn kald\u0131';

      var newIndex = Math.min(Math.floor(elapsed / 4000), LOADING_MESSAGES.length - 1);
      if (newIndex !== msgIndex) {
        msgIndex = newIndex;
        if (status) status.textContent = LOADING_MESSAGES[msgIndex];
      }
    }, 200);
  }

  function stopLoadingProgress() {
    if (state.loadingTimer) { clearInterval(state.loadingTimer); state.loadingTimer = null; }
    var fill = document.getElementById('cdProgressFill');
    if (fill) fill.style.width = '100%';
    hide('#cdLoading');
  }

  /* ── Result ── */
  function showResultWithCart(imageUrl) {
    var genImg = document.getElementById('cdResultImage');
    if (genImg) genImg.src = imageUrl;
    var genImgSmall = document.getElementById('cdResultImageSmall');
    if (genImgSmall) genImgSmall.src = imageUrl;
    var refImg = document.getElementById('cdResultRef');
    var srcImg = document.getElementById('cdRefImage');
    if (refImg && srcImg) refImg.src = srcImg.src;
    var variantSection = document.getElementById('cdVariantSection');
    if (variantSection) variantSection.style.display = 'block';
    autoSelectAllVariants();
    show('#cdResult');
    smoothScroll('#cdResult');
  }

  function autoSelectAllVariants() {
    var colorTarget = COLOR_TO_VARIANT[state.color];
    var isErkek = state.color === 'erkek';
    document.querySelectorAll('.cd-variant-btn').forEach(function (btn) {
      var val = btn.dataset.value.trim();
      var name = btn.dataset.optionName;
      if (val === 'Necklace') {
        activateInGroup(btn, '.cd-variant-btn[data-option-name="' + name + '"]');
        state.selectedOptions[name] = val;
      }
      if (colorTarget && val === colorTarget) {
        activateInGroup(btn, '.cd-variant-btn[data-option-name="' + name + '"]');
        state.selectedOptions[name] = val;
      }
      if (isErkek && val === '60cm') {
        activateInGroup(btn, '.cd-variant-btn[data-option-name="' + name + '"]');
        state.selectedOptions[name] = val;
      } else if (!isErkek && val === '50cm') {
        activateInGroup(btn, '.cd-variant-btn[data-option-name="' + name + '"]');
        state.selectedOptions[name] = val;
      }
    });
    updateCartBtn();
  }

  function hideResult() {
    hide('#cdResult');
    state.selectedOptions = {};
    deactivateAll('.cd-variant-btn');
    var btn = document.getElementById('cdCartBtn');
    if (btn) { btn.disabled = true; btn.textContent = 'Se\u00e7imleri Tamamlay\u0131n'; }
  }

  /* ── Retry ── */
  function bindRetry() {
    var btn = document.getElementById('cdRetryBtn');
    if (btn) btn.addEventListener('click', showConfirmModal);
  }
  function showConfirmModal() {
    var d = getRateData(), remaining = DAILY_LIMIT - d.count;
    var msgEl = document.getElementById('cdConfirmMsg');
    if (msgEl) {
      var msg = 'If you try again, your current design will be lost.';
      msg += remaining <= 1 ? ' Son ' + remaining + ' hakk\u0131n\u0131z kald\u0131!' : ' Kalan: ' + remaining + '/' + DAILY_LIMIT;
      msgEl.textContent = msg;
    }
    var overlay = document.getElementById('cdConfirmOverlay');
    if (overlay) overlay.style.display = 'flex';
  }
  document.addEventListener('click', function (e) {
    if (e.target.id === 'cdConfirmYes') {
      document.getElementById('cdConfirmOverlay').style.display = 'none';
      hide('#cdResult'); doGenerate();
    }
    if (e.target.id === 'cdConfirmNo' || e.target.id === 'cdConfirmOverlay') {
      document.getElementById('cdConfirmOverlay').style.display = 'none';
    }
  });

  /* ── Download ── */
  function bindDownload() {
    var btn = document.getElementById('cdDownloadBtn');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (!state.generatedImageUrl) return;
      btn.textContent = '\u0130ndiriliyor...';
      fetch(state.generatedImageUrl)
        .then(function (r) { return r.blob(); })
        .then(function (blob) {
          var url = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = 'medusa-design.png';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
          btn.textContent = 'Download';
        })
        .catch(function () {
          window.open(state.generatedImageUrl, '_blank');
          btn.textContent = 'Download';
        });
    });
  }

  /* ── Variants ── */
  function bindVariants() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cd-variant-btn');
      if (!btn) return;
      activateInGroup(btn, '.cd-variant-btn[data-option-name="' + btn.dataset.optionName + '"]');
      state.selectedOptions[btn.dataset.optionName] = btn.dataset.value;
      updateCartBtn();
    });
  }
  function findVariant() {
    if (!state.productData || !state.productData.variants) return null;
    return state.productData.variants.find(function (v) {
      return v.options.every(function (val, i) {
        return state.selectedOptions[state.productData.options[i]] === val;
      });
    });
  }
  function updateCartBtn() {
    var btn = document.getElementById('cdCartBtn');
    if (!btn || !state.productData) return;
    var allPicked = state.productData.options.every(function (name) { return state.selectedOptions[name]; });
    if (!allPicked) { btn.disabled = true; btn.textContent = 'Se\u00e7imleri Tamamlay\u0131n'; return; }
    var v = findVariant();
    if (v && v.available) { btn.disabled = false; btn.textContent = 'Sepete Ekle \u2014 ' + stripHtml(v.price); }
    else { btn.disabled = true; btn.textContent = 'Stokta Yok'; }
  }

  /* ── Cart ── */
  function bindCart() {
    var btn = document.getElementById('cdCartBtn');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var v = findVariant();
      if (!v || !v.available) return;
      btn.disabled = true; btn.textContent = 'Ekleniyor...';
      var props = {
        '_Design Image': state.generatedImageUrl,
        'Design Mode': state.mode === 'prompt' ? 'Text Prompt' : state.mode === 'mydesign' ? 'My Design' : 'Photo'
      };
      if (state.mode === 'prompt') {
        var el = document.getElementById('cdPrompt');
        if (el && el.value.trim()) props['Customer Prompt'] = el.value.trim();
      }
      // Use hidden form submit — most reliable, bypasses all theme interceptors
      var form = document.createElement('form');
      form.method = 'POST';
      form.action = '/cart/add';
      form.style.display = 'none';

      var idInput = document.createElement('input');
      idInput.name = 'id'; idInput.value = v.id;
      form.appendChild(idInput);

      var qtyInput = document.createElement('input');
      qtyInput.name = 'quantity'; qtyInput.value = '1';
      form.appendChild(qtyInput);

      var returnInput = document.createElement('input');
      returnInput.name = 'return_to'; returnInput.value = '/checkout';
      form.appendChild(returnInput);

      Object.keys(props).forEach(function(key) {
        var inp = document.createElement('input');
        inp.name = 'properties[' + key + ']';
        inp.value = props[key];
        form.appendChild(inp);
      });

      document.body.appendChild(form);
      form.submit();
    });
  }

  /* ── Design History ── */
  var HISTORY_KEY = 'cd_design_history';
  var MAX_HISTORY = 20;

  function saveDesignToHistory(imageUrl) {
    try {
      var v = findVariant();
      var history = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');
      history.unshift({
        url: imageUrl,
        shape: state.shape,
        color: state.color,
        style: state.style,
        mode: state.mode,
        variantId: v ? v.id : null,
        variantTitle: v ? v.title : null,
        date: new Date().toISOString()
      });
      if (history.length > MAX_HISTORY) history = history.slice(0, MAX_HISTORY);
      localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
    } catch (e) {}
  }

  /* ── Helpers ── */
  function on(sel, ev, fn) { document.querySelectorAll(sel).forEach(function (el) { el.addEventListener(ev, fn); }); }
  function activateInGroup(el, sel) { document.querySelectorAll(sel).forEach(function (b) { b.classList.remove('is-active'); }); el.classList.add('is-active'); }
  function deactivateAll(sel) { document.querySelectorAll(sel).forEach(function (b) { b.classList.remove('is-active'); }); }
  function show(sel) { var el = document.querySelector(sel); if (el) el.style.display = ''; }
  function hide(sel) { var el = document.querySelector(sel); if (el) el.style.display = 'none'; }
  function smoothScroll(sel) { var el = document.querySelector(sel); if (el) setTimeout(function () { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 100); }
  function stripHtml(str) { return str.replace(/<[^>]*>/g, ''); }
  function showError(msg) { var el = document.getElementById('cdError'); if (el) { el.textContent = msg; el.style.display = ''; } }
  function hideError() { var el = document.getElementById('cdError'); if (el) el.style.display = 'none'; }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
